import { render, staticRenderFns } from "./programme_detail.vue?vue&type=template&id=3256548a&scoped=true&"
import script from "./programme_detail.vue?vue&type=script&lang=js&"
export * from "./programme_detail.vue?vue&type=script&lang=js&"
import style0 from "./programme_detail.vue?vue&type=style&index=0&id=3256548a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3256548a",
  null
  
)

export default component.exports